  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>note_add</mat-icon>
    </span>
    My Drive
    <button mat-icon-button (click)="closeAll()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content>


    <div class="myforms">
      <div class="drive mainLink">

        <div class="folderName" (click)="GetAllMyDrive()">
          <mat-icon class="type">account_balance</mat-icon>
          My Drive
        </div>

        <mat-tree [dataSource]="dataSourceFileManager" [treeControl]="treeControlFileManager">
          <mat-tree-node [ngClass]="{ 'active': activeNodeFileManager === node.fileManagerItemID }"
            *matTreeNodeDef="let node" matTreeNodePadding matTreeNodePaddingIndent="20">
            <div class="folderRow">
              <mat-icon class="mat-icon-rtl-mirror arrowIcon" style="visibility: hidden;">
                arrow_right
              </mat-icon>

              <div class="folderName">
                <mat-icon class="folder" *ngIf="node.isShared == false"
                  (click)="showChildFolders(node)">folder</mat-icon>
                <mat-icon class="folder" *ngIf="node.isShared == true"
                  (click)="showChildFolders(node)">folder_shared</mat-icon>
                <span class="flname" (click)="showChildFolders(node)">{{node.name}}</span>
              </div>
            </div>
          </mat-tree-node>

          <mat-tree-node [ngClass]="{ 'active': activeNodeFileManager === node.fileManagerItemID }"
            *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding matTreeNodePaddingIndent="20">
            <div class="folderRow" matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
              <mat-icon class="mat-icon-rtl-mirror arrowIcon">
                {{treeControl.isExpanded(node) ? 'arrow_drop_down' : 'arrow_right'}}
              </mat-icon>
              <div class="folderName">
                <mat-icon class="folder" *ngIf="node.isShared == false"
                  (click)="showChildFolders(node)">folder</mat-icon>
                <mat-icon class="folder" *ngIf="node.isShared == true"
                  (click)="showChildFolders(node)">folder_shared</mat-icon>
                <span class="flname" (click)="showChildFolders(node)">{{node.name}}</span>
              </div>
            </div>

          </mat-tree-node>
        </mat-tree>

        <div class="folderName" (click)="getSharedWithMeMyDrive()" [ngClass]="{ 'active': SharedWithMeMyDriveactive }">
          <mat-icon class="type">portrait</mat-icon> Shared with me
        </div>

      </div>

      <div class="driveDetail" *ngIf="isShowMyDrive">
        <div class="breadcumb">
          <span (click)="breadCrumbMyDriveMainClick()">My Drive</span>
          <span *ngFor="let m of menuHeaderMyDrive;let i= index;">
            <mat-icon class="sidenav-breaddiv">keyboard_arrow_right</mat-icon>
            <a (click)="breadCrumbMyDrive(menuHeaderMyDrive, i)">{{ m.label }}</a>
          </span>
        </div>

        <mat-card class="files">
          <table class="mat-table">
            <thead>
              <tr class="mat-header-row">
                <th class="mat-header-cell wstar">&nbsp; </th>
                <th class="mat-header-cell wstar"></th>
                <th class="mat-header-cell wstar"></th>
                <th class="mat-header-cell">Name</th>
                <th class="mat-header-cell date">Created On</th>
                <th class="mat-header-cell date">Modified On</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let form of MyDrivefoldersList; let i = index;">
                <tr class="mat-row foldericon" (click)="radioChangeMyDrive(form)">
                  <td class="mat-cell wstar">
                    <span class="checkbo" *ngIf="form.isFile == true">
                      <mat-radio-button color="primary" value="i" [checked]="form.isChecked"
                        (change)="radioChangeMyDrive(form)"></mat-radio-button>
                    </span>
                  </td>

                  <ng-container *ngIf="getIsFavorite(form) == true; else showFavorite">
                    <td class="mat-cell">
                      <mat-icon class="fav">grade</mat-icon>
                    </td>
                  </ng-container>

                  <ng-template #showFavorite>
                    <td class="mat-cell">
                      <mat-icon class="star">grade</mat-icon>
                    </td>
                  </ng-template>

                  <td class="mat-cell docType" *ngIf="form.isFile == false && form.isShared == false">
                    <mat-icon>folder</mat-icon>
                  </td>

                  <td class="mat-cell docType" *ngIf="form.isFile == false && form.isShared == true">
                    <mat-icon>folder_shared</mat-icon>
                  </td>

                  <td class="mat-cell formIcon" *ngIf="form.isFile == true">
                    <ng-container *ngIf="form.fileType == 'pdf'">
                      <img class="fileIcon" src="../../../../../assets/icons/fileType/pdf_icon.svg" alt="Pdf File" />
                    </ng-container>
                    <ng-container *ngIf="form.fileType == 'png'">
                      <img class="fileIcon" src="../../../../../assets/icons/fileType/020-png.svg" alt="png File" />
                    </ng-container>
                    <ng-container *ngIf="form.fileType == 'jpg'">
                      <img class="fileIcon" src="../../../../../assets/icons/fileType/014-jpg.svg" alt="jpg File" />
                    </ng-container>
                    <mat-icon *ngIf="form.fileType != 'pdf' && form.fileType != 'png' && form.fileType != 'jpg'">
                      description
                    </mat-icon>
                  </td>

                  <td class="mat-cell" *ngIf="form.isFile == false">
                    <span class="formName" matTooltipClass="tooltip" matTooltipClass="tooltip"
                      matTooltip="{{form.name}}">{{ form.name }}</span>
                  </td>

                  <td class="mat-cell" *ngIf="form.isFile == true">
                    <p class="formName" matTooltipClass="tooltip" matTooltipClass="tooltip" matTooltip="{{form.name}}">
                      {{ form.name }}</p>
                    <span *ngIf="form.fileSize" class="fileSize">{{ form.fileSize }}</span>
                  </td>

                  <td class="mat-cell">
                    {{ form.createdOn+'Z' | date: "MM/dd/yyyy" }}
                  </td>

                  <td class="mat-cell" *ngIf="form.updatedOn!=null">
                    {{ form.updatedOn+'Z' | date: "MM/dd/yyyy" }}
                  </td>

                  <td class="mat-cell" *ngIf="form.updatedOn==null">
                    {{ form.createdOn+'Z' | date: "MM/dd/yyyy" }}
                  </td>

                </tr>
              </ng-container>

              <ng-container *ngIf="foldersMyDriveListShow">
                <tr>
                  <td colspan="7">
                    <p class="nocontent">No Items Found</p>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </mat-card>
      </div>

      <div class="driveDetail" *ngIf="isSharedWithMeMyDrive">
        <div class="breadcumb">
          <span (click)="breadCrumbMainSHaredWithMeMyDriveClick()">Shared with me</span>
          <span *ngFor="let m of menuHeaderMyDrive;let i= index;">
            <mat-icon class="sidenav-breaddiv">keyboard_arrow_right</mat-icon>
            <a (click)="breadCrumbSharedWithMeMyDrive(menuHeaderMyDrive, i)">{{ m.label }}</a>
          </span>
        </div>

        <mat-card class="files">
          <table class="mat-table">
            <thead>
              <tr class="mat-header-row">
                <th class="mat-header-cell wstar">&nbsp; </th>
                <th class="mat-header-cell wstar"></th>
                <th class="mat-header-cell wstar"></th>
                <th class="mat-header-cell">Name</th>
                <th class="mat-header-cell" *ngIf="parentID==0">Shared By</th>
                <th class="mat-header-cell date">Created On</th>
                <th class="mat-header-cell date">Modified On</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let form of SharedWithMeMyDriveFolderList; let i = index;">
                <tr class="mat-row foldericon" (click)="radioChangeMyDriveSharedWithMe(form)">
                  <td class="mat-cell wstar">
                    <span class="checkbo" *ngIf="form.isFile == true">
                      <mat-radio-button color="primary" value="i" [checked]="form.isChecked"
                        (change)="radioChangeMyDriveSharedWithMe(form)">

                      </mat-radio-button>
                    </span>
                  </td>

                  <ng-container *ngIf="getIsFavorite(form) == true; else showFavorite">
                    <td class="mat-cell">
                      <mat-icon class="fav">grade</mat-icon>
                    </td>
                  </ng-container>

                  <ng-template #showFavorite>
                    <td class="mat-cell">
                      <mat-icon class="star">grade</mat-icon>
                    </td>
                  </ng-template>

                  <td class="mat-cell docType" *ngIf="form.isFile == false">
                    <mat-icon>folder</mat-icon>
                  </td>

                  <td class="mat-cell formIcon" *ngIf="form.isFile == true">
                    <ng-container *ngIf="form.fileType == 'pdf'">
                      <img class="fileIcon" src="../../../../../assets/icons/fileType/pdf_icon.svg" alt="Pdf File" />
                    </ng-container>
                    <ng-container *ngIf="form.fileType == 'png'">
                      <img class="fileIcon" src="../../../../../assets/icons/fileType/020-png.svg" alt="png File" />
                    </ng-container>
                    <ng-container *ngIf="form.fileType == 'jpg'">
                      <img class="fileIcon" src="../../../../../assets/icons/fileType/014-jpg.svg" alt="jpg File" />
                    </ng-container>
                    <mat-icon *ngIf="form.fileType != 'pdf' && form.fileType != 'png' && form.fileType != 'jpg'">
                      description
                    </mat-icon>
                  </td>

                  <td class="mat-cell" *ngIf="form.isFile == false">
                    <span class="formName" matTooltipClass="tooltip" matTooltip="{{form.name}}">{{ form.name }}</span>
                  </td>

                  <td class="mat-cell" *ngIf="form.isFile == true">
                    <p class="formName" matTooltipClass="tooltip" matTooltip="{{form.name}}">{{ form.name }}</p>
                    <span *ngIf="form.fileSize" class="fileSize">{{ form.fileSize }}</span>
                  </td>

                  <td class="mat-cell" *ngIf="parentID==0">
                    <span class="formName" matTooltipClass="tooltip">
                      {{ form.sharedbyFirstName }} {{ form.sharedbyLastName }}
                    </span>
                  </td>

                  <td class="mat-cell">
                    {{ form.createdOn+'Z' | date: "MM/dd/yyyy" }}
                  </td>

                  <td class="mat-cell" *ngIf="form.updatedOn!=null">
                    {{ form.updatedOn+'Z' | date: "MM/dd/yyyy" }}
                  </td>

                  <td class="mat-cell" *ngIf="form.updatedOn==null">
                    {{ form.createdOn+'Z' | date: "MM/dd/yyyy" }}
                  </td>

                </tr>
              </ng-container>

              <ng-container *ngIf="SharedWithMeMyDriveFolderList.length==0">
                <tr>
                  <td colspan="7">
                    <p class="nocontent">No Items Found</p>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </mat-card>
      </div>

    </div>


  </mat-dialog-content>

  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" (click)="closeAll()">Cancel</button>
    <button mat-button color="primary" [disabled]="!selectButtonMyDriveShow"
      (click)="AddDocumentfromMyDrive()">Select</button>
  </mat-dialog-actions>





